import { useField } from "formik";
import { IdentityMelcoAnalyticsModelsWidgetListItem } from "melco-shared-logic";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const useAddRemoveWizards = () => {
  const { t } = useTranslation();

  const [{ value: wizards }, , { setValue: setWizards, setError }] =
    useField<IdentityMelcoAnalyticsModelsWidgetListItem[]>("wizard_list");

  const isAlreadyAdded = (wizard: IdentityMelcoAnalyticsModelsWidgetListItem) =>
    wizard.code && wizards.find((d) => d.code === wizard.code);

  const addUsersWizard = useCallback(
    (toAdd: IdentityMelcoAnalyticsModelsWidgetListItem[]) => {
      const addedWizards = toAdd
        .filter((d) => !isAlreadyAdded(d))
        .map((wizard) => {
          const { code, name, type, url } = wizard;

          return {
            code,
            name,
            type,
            url,
          };
        });

      setWizards([...(wizards ?? []), ...addedWizards]);
    },
    [wizards, setWizards, t]
  );

  const removeUsersWizard = useCallback(
    (toRemove: { code: string }[]) => {
      const idsToRemove = toRemove.map((d) => d.code);

      setWizards(wizards.filter((d) => !idsToRemove.includes(d.code!)));

      // reset field error as removing a field changes the index positions which could lead to errors being added to the wrong field
      setError(undefined);
    },
    [wizards, setWizards, setError]
  );

  return {
    wizards,
    addUsersWizard,
    removeUsersWizard,
    isAlreadyAdded,
  };
};
